export default function sendCSV2Analytics(schema, data) {
  if (!window._csq) {
    return;
  }

  const event = new schema(data);

  window._csq.push({
    v2: event,
  });
}



// WEBPACK FOOTER //
// ./client/app/common/clickstream/send-cs-v2-analytics.js